import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
const Chart = dynamic(() => import("react-apexcharts"), {
  ssr: false
});
import dynamic from "next/dynamic";
import { useGlobalData } from "@/contexts/GlobalData";
import useFormatter from "@/hook/useFormatter";
import formatDate from "@/common/function/formatDate";
export interface StackColumnChartPropsType extends GeneralPropsType {
  curve?: "smooth" | "straight" | "stepline";
}
function AreaChartOverView({
  children,
  className,
  curve
}: StackColumnChartPropsType) {
  const {
    chartData
  } = useGlobalData();
  const {
    formatValue
  } = useFormatter();
  const series = [{
    name: "TON",
    data: chartData?.map((item: any) => [new Date(item.created), item.data?.rateToken?.TON?.USD]) ?? [300, 200, 275, 90, 296, 170, 120, 131, 125]
  }];
  const options: any = {
    chart: {
      type: "line",
      toolbar: {
        show: false
      },
      parentHeightOffset: 0,
      height: "100%",
      // width: "100%",
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
      zoom: {
        enabled: false
      }
    },
    stroke: {
      width: 1,
      curve: curve ?? "smooth"
    },
    dataLabels: {
      enabled: false
    },
    grid: {
      show: false
    },
    xaxis: {
      labels: {
        show: false
      },
      axisTicks: {
        show: false
      },
      type: "datetime",
      // categories: [30, 40, 35, 50, 49, 60, 70, 91, 125],
      tickAmount: 1,
      axisBorder: {
        show: false
      },
      tooltip: {
        enabled: false
        // theme: "dark",
        // offsetY: -10,
        // style: {
        //   width: '50px !important',
        // }
      }
    },
    yaxis: {
      tickAmount: 4,
      show: false,
      stepSize: 0.5
    },
    tooltip: {
      theme: "dark",
      // Options: 'dark', 'light'
      style: {
        backgroundColor: "#000" // Custom background color
      },
      y: {
        formatter: (value: number) => formatValue(value)
      },
      x: {
        formatter: (value: number) => {
          try {
            const date = new Date(value)?.toISOString();
            return formatDate(date, false, "mm-dd");
          } catch (e) {
            return "";
          }
        }
      }
    },
    colors: ["#60D591"]
  };
  return <div className={clsx(styles.container, className)} data-sentry-component="AreaChartOverView" data-sentry-source-file="index.tsx">
            <Chart options={options} series={series} type="line" height="100%" data-sentry-element="Chart" data-sentry-source-file="index.tsx" />
        </div>;
}
export default AreaChartOverView;